import config from '../../config';
import { BlobServiceClient } from '@azure/storage-blob';
import * as Msal from 'msal';
import { apiGet } from '../../services';

const msalConfig = {
    auth: {
        clientId: config.azure.clientId,
        authority: config.azure.authority,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
};

export const msalScope = {
    scopes: ['user.read', 'files.readwrite', 'openid', 'profile'],
    prompt: 'select_account',
};

export const msalInstance = new Msal.UserAgentApplication(msalConfig);

export const msalLogout = () => {
    msalInstance.logout();
};

const getSasToken = (uploadType, filename, overrideFilename, userToken) => {
    return new Promise((resolve, reject) => {
        apiGet(
            `getuploadurlwithtoken?type=${uploadType}&filename=${filename}&generateFileName=${overrideFilename || true}`,
            userToken,
            response => resolve(response),
            error => reject(error)
        );
    });
};

export const uploadType = {
    taskCompletion: 'TaskCompletion',
    taskFile: 'Task',
    linkedIn: 'LinkedIn',
    blog: 'Blog',
    QuestionAnswer: 'QuestionAnswer',
};

export const uploadFileToAzure = async (userToken, file, uploadType, setProgress, callback, overrideFilename) => {
    try {
        const sasTokenResponse = await getSasToken(uploadType, file.name, overrideFilename, userToken);

        const blobServiceUrl = `${sasTokenResponse.blobServiceUrl}?${sasTokenResponse.token}`;

        let blobServiceClient = new BlobServiceClient(blobServiceUrl);

        const containerClient = blobServiceClient.getContainerClient(sasTokenResponse.containerName);
        const blockBlobClient = containerClient.getBlockBlobClient(sasTokenResponse.filePath);

        const options = {
            blockSize: 4 * 1024 * 1024, // 4 MB blocks
            concurrency: 10, // number of parallel uploads
            blobHTTPHeaders: { blobContentType: file.type },
            onProgress: ev => {
                const percent = Math.round((ev.loadedBytes / file.size) * 100);
                setProgress(percent);
            },
        };

        const onComplete = () => {
            callback({
                name: file.name,
                path: sasTokenResponse.fileName,
                folder: sasTokenResponse.folder,
                ext: sasTokenResponse.fileExtension,
                size: file.size,
                url: sasTokenResponse.readUriWithToken,
            });
        };

        await blockBlobClient.uploadData(file, options).then(() => onComplete());

        return sasTokenResponse.fileName;
    } catch (error) {
        console.error('Failed to upload file:', error);
        throw error;
    }
};
